import {
  absRoute, PAGE_PROFILE, ROUTE_ORGANIZATION, ROUTE_PROFILE
} from 'src/app/app-route.constants';
import { BACKOFFICE_ROLE_STANDARD, BACKOFFICE_ROLE_VIEWER } from 'src/app/model-backoffice/auth/cc-backoffice-permission.config';
import { Permission } from './session';



const PERM_PROFILE_READ: Permission = {
  id: 'profile.read',
  translationKey: 'Profile read',
  routes: [
    {
      appPath: absRoute(ROUTE_PROFILE),
      pagePath: absRoute(PAGE_PROFILE)
    }
  ]
};

// Organization
const PERM_ORG_READ: Permission = {
  id: 'organization.read',
  translationKey: 'Organization read',
  routes: [
    {
      appPath: absRoute(ROUTE_ORGANIZATION),
    },

  ]
};

export const PERMISSION_MAP = new Map<string, Permission[]>([
  [BACKOFFICE_ROLE_STANDARD.id, [PERM_PROFILE_READ, PERM_ORG_READ]],
  [BACKOFFICE_ROLE_VIEWER.id, [PERM_PROFILE_READ, PERM_ORG_READ]]
]);
